export default __webpack_public_path__ + "static/media/star-half.e8b5e8c3.svg";